import { useGetAllAssignmentMarkQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import AssignmentMark from "./AssignmentMark";

export default function AssignmentMarks() {
  const {
    data: assignmentmark,
    isLoading,
    isError,
  } = useGetAllAssignmentMarkQuery() || {};
  const pendingMark =
    assignmentmark?.filter((mark) => mark.status === "pending") || {};
  const sentMark =
    assignmentmark?.filter((mark) => mark.status === "published") || {};
  const totalMark = assignmentmark || {};
  // decide what to render
  let content = null;
  if (isLoading)
    content = (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>
          Loading....
        </td>
      </tr>
    );
  if (!isLoading && isError)
    content = (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>
          There was an error
        </td>
      </tr>
    );
  if (!isLoading && !isError && assignmentmark?.length === 0)
    content = (
      <tr>
        <td colSpan="4" style={{ textAlign: "center" }}>
          No videos found
        </td>
      </tr>
    );
  if (!isLoading && !isError && assignmentmark?.length > 0) {
    content = assignmentmark.map((assignmentmark, i) => (
      <AssignmentMark key={i} assignmentmark={assignmentmark} />
    ));
  }
  return (
    <div className="px-3 py-20 bg-opacity-10">
      <ul className="assignment-status">
        <li>
          Total <span>{totalMark.length}</span>
        </li>
        <li>
          Pending
          <span>{pendingMark.length}</span>
        </li>
        <li>
          Mark Sent <span>{sentMark.length}</span>
        </li>
      </ul>
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Assignment</th>
              <th className="table-th">Date</th>
              <th className="table-th">Student Name</th>
              <th className="table-th">Repo Link</th>
              <th className="table-th">Mark</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">{content}</tbody>
        </table>
      </div>
    </div>
  );
}
